import { FormEvent, useEffect, useState } from "react";
import { Button, ButtonGroup, Col, Form, Row, ToggleButton } from "react-bootstrap";
import { toast } from "react-toastify";
import { defineCheckBoxInput, defineValueInInput, getValueFromInput, showInputErrorMsg } from "../../../../components/funcForInput";
import removeAllErrorMsg from "../../../../components/funcRemoveAllErros";
import funcSleep from "../../../../components/funcSleep";
import LoadingModal from "../../../../components/loadingModal";
import { reqPut, ApiEndpoints, reqPatch } from "../../../../config/apiClient";
import stylesCheckbox from "../../../colaborador/styles/colaborador.module.css";

export default function EscalaFlexivelForm({ escala, handleUpdate }: iProps) {
    useEffect(() => {
        if (Object.values(escala).length > 0) {
            carregarDados(escala);
        }
    }, [escala]);

    const [loading, setLoading] = useState<boolean>(false);

    const [registrarIntervalo, setRegistrarIntervalo] = useState<boolean>(true);
    const [calcularHorarioNoturno, setCalcularHorarioNoturno] = useState<number>(0);
    const [tipoDiurnoNoturno, setTipoDiurnoNoturno] = useState<string>("0");

    async function carregarDados(escala: any) {
        setRegistrarIntervalo(escala.intervalo_registrar === 1 ? true : false);
        defineCheckBoxInput("escala_banco_horas", escala.escala_banco_horas === 1 ? true : false);
        setTipoDiurnoNoturno(String(escala.tipo_diurna_noturna));

        setCalcularHorarioNoturno(escala.horario_noturno);
        if (escala.horario_noturno === 1) {
            defineValueInInput("noturno_inicio", escala.noturno_inicio);
            defineValueInInput("noturno_fim", escala.noturno_fim);
        }
        defineValueInInput("horario_noturno_prorrogado", escala.noturno_prorrogado);
    }

    async function handleSubmit(event: FormEvent<HTMLFormElement>) {
        event.preventDefault();
        event.stopPropagation();
        removeAllErrorMsg();

        const form: any = event.target;
        let formValidado = true;
        let dados = {
            id_escala: Object.values(escala).length === 0 ? null : escala.id_escala,
            codigo: Number(getValueFromInput("codigo")),
            descricao: getValueFromInput("descricao"),
            id_tipo: 3,
            escala_sdf: 0,
            tipo_diurna_noturna: Number(form.tipo_diurna_noturna.value),
            atualizada: 1,
            data_base: '2022-05-01',
            escala_base: null,
            escala_banco_horas: form.escala_banco_horas.checked === true ? 1 : 0,
            segunda: null,
            segunda_escala_flexivel: null,
            segunda_gerar_ocorrencias: null,
            segunda_calcular_horas: null,
            segunda_entrada: null,
            segunda_saida: null,
            segunda_intervalo_entrada: null,
            segunda_intervalo_saida: null,
            terca: null,
            terca_escala_flexivel: null,
            terca_gerar_ocorrencias: null,
            terca_calcular_horas: null,
            terca_entrada: null,
            terca_saida: null,
            terca_intervalo_entrada: null,
            terca_intervalo_saida: null,
            quarta: null,
            quarta_escala_flexivel: null,
            quarta_gerar_ocorrencias: null,
            quarta_calcular_horas: null,
            quarta_entrada: null,
            quarta_saida: null,
            quarta_intervalo_entrada: null,
            quarta_intervalo_saida: null,
            quinta: null,
            quinta_escala_flexivel: null,
            quinta_gerar_ocorrencias: null,
            quinta_calcular_horas: null,
            quinta_entrada: null,
            quinta_saida: null,
            quinta_intervalo_entrada: null,
            quinta_intervalo_saida: null,
            sexta: null,
            sexta_escala_flexivel: null,
            sexta_gerar_ocorrencias: null,
            sexta_calcular_horas: null,
            sexta_entrada: null,
            sexta_saida: null,
            sexta_intervalo_entrada: null,
            sexta_intervalo_saida: null,
            sabado: null,
            sabado_escala_flexivel: null,
            sabado_gerar_ocorrencias: null,
            sabado_calcular_horas: null,
            sabado_entrada: null,
            sabado_saida: null,
            sabado_intervalo_entrada: null,
            sabado_intervalo_saida: null,
            domingo: null,
            domingo_escala_flexivel: null,
            domingo_gerar_ocorrencias: null,
            domingo_calcular_horas: null,
            domingo_entrada: null,
            domingo_saida: null,
            domingo_intervalo_entrada: null,
            domingo_intervalo_saida: null,
            horario_entrada: null,
            intervalo_entrada: null,
            intervalo_saida: null,
            horario_saida: null,
            intervalo_registrar: form.registrar_intervalo.checked === true ? 1 : 0,
            tempo_maximo_diario_tolerancia: null,
            tolerancia_extra_entrada: null,
            tolerancia_atraso_entrada: null,
            tolerancia_extra_saida: null,
            tolerancia_atraso_saida: null,
            horario_noturno: Number(form.horario_noturno.value),
            noturno_inicio: form.noturno_inicio.value,
            noturno_fim: form.noturno_fim.value,
            noturno_prorrogado: Number(form.horario_noturno_prorrogado.value),
        };

        // Validação Identificação
        if (dados.codigo === 0) {
            showInputErrorMsg("codigo");
            // form.codigo.nextElementSibling.style.display = "block";
            formValidado = false;
        }
        if (dados.descricao === "") {
            showInputErrorMsg("descricao");
            // form.descricao.nextElementSibling.style.display = "block";
            formValidado = false;
        }

        // Validação Adicionar Noturno
        if (dados.horario_noturno === 1) {
            if (dados.noturno_inicio === "") {
                form.noturno_inicio.nextElementSibling.style.display = "block";
                formValidado = false;
            }
            if (dados.noturno_fim === "") {
                form.noturno_fim.nextElementSibling.style.display = "block";
                formValidado = false;
            }
        }
        if (dados.horario_noturno === 0) {
            dados.noturno_inicio = null;
            dados.noturno_fim = null;
        }

        console.log(dados);

        if (!formValidado) {
            return;
        }

        if (dados.id_escala === null) {
            await cadastrar(dados);
        }
        if (dados.id_escala > 0) {
            await editar(dados);
        }
    }

    async function cadastrar(dados: any) {
        setLoading(true);
        const api = await reqPut(ApiEndpoints.pontoEscalaCadastrar, dados);
        if (api.status === 201) {
            toast.success("Escala cadastrada com sucesso!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            await funcSleep(600);
            window.location.assign(`/ponto/escalas`);
        } else {
            setLoading(false);
        }
    }

    async function editar(dados: any) {
        setLoading(true);
        const api = await reqPatch(ApiEndpoints.pontoEscalaEditar, dados);
        if (api.status === 200) {
            toast.success("Escala editada com sucesso!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            await funcSleep(600);
            window.location.assign(`/ponto/escalas`);
        } else {
            setLoading(false);
        }
    }

    function handleChangeHorarioNoturno(event: any) {
        const calcular_noturno = Number(event.target.value);
        setCalcularHorarioNoturno(calcular_noturno);
    }

    return (
        <div>
            <LoadingModal show={loading} handleClose={() => setLoading(false)} />
            <Form id="formEscalaNormal" onSubmit={handleSubmit} style={{ position: "relative" }} noValidate>
                <Row className="mb-15-forms">
                    <Col className="col-2">
                        <Form.Group>
                            <Form.Label>Definições da escala:</Form.Label>
                            <Form.Check type="switch" id="registrar_intervalo" label="Necessário registrar o intervalo" checked={registrarIntervalo} className={stylesCheckbox.inputCheck} onChange={(e) => setRegistrarIntervalo(e.currentTarget.checked)} />
                            <Form.Check type="switch" id="escala_banco_horas" label="Escala com Banco de Horas" defaultChecked={false} className={stylesCheckbox.inputCheck} />
                        </Form.Group>
                        <ButtonGroup className="mb-2">
                            <ToggleButton id="tipo_diurna" name="tipo_diurna_noturna" type="radio" variant="outline-primary" value={"0"} checked={tipoDiurnoNoturno === "0"} onChange={(e) => setTipoDiurnoNoturno("0")}>
                                Diurno
                            </ToggleButton>
                            <ToggleButton id="tipo_noturna" name="tipo_diurna_noturna" type="radio" variant="outline-primary" value={"1"} checked={tipoDiurnoNoturno === "1"} onChange={(e) => setTipoDiurnoNoturno("1")}>
                                Noturno
                            </ToggleButton>
                        </ButtonGroup>
                    </Col>
                </Row>

                <Row className="mb-15-forms">
                    <Col className="col-3">
                        <Form.Label>Calcular adicional noturno?</Form.Label>
                        <Form.Select aria-label="Calcular adicional noturno?" value={calcularHorarioNoturno} onChange={(e) => handleChangeHorarioNoturno(e)} id="horario_noturno">
                            <option value="0">Não</option>
                            <option value="1">Sim</option>
                        </Form.Select>
                    </Col>
                    <Col className="col-3" style={{ display: calcularHorarioNoturno === 1 ? "block" : "none" }}>
                        <Form.Group>
                            <Form.Label>Horário Noturno Início:</Form.Label>
                            <Form.Control name="noturno_inicio" type="time" id="noturno_inicio" placeholder="" />
                            <Form.Control.Feedback type="invalid">Informe o horário de início!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-3" style={{ display: calcularHorarioNoturno === 1 ? "block" : "none" }}>
                        <Form.Group>
                            <Form.Label>Horário Noturno Fim:</Form.Label>
                            <Form.Control name="noturno_fim" type="time" id="noturno_fim" placeholder="" />
                            <Form.Control.Feedback type="invalid">Informe o horário de fim!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-3">
                        <Form.Label>Horário Noturno Prorrogado?</Form.Label>
                        <Form.Select aria-label="Horário Noturno Prorrogado?" id="horario_noturno_prorrogado">
                            <option value="0">Não</option>
                            <option value="1">Sim</option>
                        </Form.Select>
                    </Col>
                </Row>

                <Button variant="success" type="submit">
                    Salvar Escala
                </Button>
            </Form>
        </div>
    );
}
interface iProps {
    escala: any;
    handleUpdate: any;
}
